import React from 'react'
import { Plus, X, Mail } from 'lucide-react'
import { ShadcnButton } from '../ui'
import { Input as ShadcnInput } from '../ui/Input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'
import { Checkbox } from '../ui/checkbox'
import { Label } from '../ui/label'
import { LeadEmail } from '../../types'

interface MultiEmailInputProps {
 value: LeadEmail[]
 onChange: (emails: LeadEmail[]) => void
 error?: string
 required?: boolean
}

export const MultiEmailInput: React.FC<MultiEmailInputProps> = ({
 value = [],
 onChange
}) => {
 const handleAdd = () => {
 onChange([...value, { email: '', type: 'personal', isPrimary: value.length === 0 }])
 }

 const handleRemove = (index: number) => {
 const newEmails = value.filter((_, i) => i !== index)
 // Se remover o primary, marca o primeiro como primary
 if (newEmails.length > 0 && !newEmails.some(e => e.isPrimary)) {
 newEmails[0].isPrimary = true
 }
 onChange(newEmails)
 }

 const handleEmailChange = (index: number, email: string) => {
 const newEmails = [...value]
 newEmails[index] = { ...newEmails[index], email }
 onChange(newEmails)
 }

 const handleTypeChange = (index: number, type: 'personal' | 'work' | 'other') => {
 const newEmails = [...value]
 newEmails[index] = { ...newEmails[index], type }
 onChange(newEmails)
 }

 const handlePrimaryChange = (index: number) => {
 const newEmails = value.map((e, i) => ({
 ...e,
 isPrimary: i === index
 }))
 onChange(newEmails)
 }

 // Se não houver nenhum email, adiciona um campo vazio
 const emails = value.length === 0 ? [{ email: '', type: 'personal' as const, isPrimary: true }] : value

 return (
 <div className="space-y-3">
 {emails.map((emailObj, index) => (
 <div key={index} className="border border-border rounded-lg p-3 space-y-2">
 <div className="flex gap-2">
 <div className="flex-1 relative">
 <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground z-10 pointer-events-none" />
 <ShadcnInput
 type="email"
 value={emailObj.email}
 onChange={(e) => handleEmailChange(index, e.target.value)}
 placeholder="email@exemplo.com"
 className="pl-10"
 />
 </div>
 {emails.length > 1 && (
 <button
 type="button"
 onClick={() => handleRemove(index)}
 className="p-2 text-muted-foreground hover:text-red-600 dark:hover:text-red-400 transition-colors"
 title="Remover e-mail"
 >
 <X className="h-5 w-5" />
 </button>
 )}
 </div>
 
 <div className="flex gap-2 flex-wrap items-center">
 <Select
 value={emailObj.type}
 onValueChange={(value) => handleTypeChange(index, value as 'personal' | 'work' | 'other')}
 >
 <SelectTrigger className="h-7 text-xs w-auto min-w-[100px]">
 <SelectValue />
 </SelectTrigger>
 <SelectContent>
 <SelectItem value="personal">Pessoal</SelectItem>
 <SelectItem value="work">Trabalho</SelectItem>
 <SelectItem value="other">Outro</SelectItem>
 </SelectContent>
 </Select>
 
 <div className="flex items-center space-x-2">
 <Checkbox
 id={`email-primary-${index}`}
 checked={emailObj.isPrimary}
 onCheckedChange={() => handlePrimaryChange(index)}
 />
 <Label
 htmlFor={`email-primary-${index}`}
 className="text-xs font-normal cursor-pointer"
 >
 Principal
 </Label>
 </div>
 </div>
 </div>
 ))}
 
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleAdd}
 className="w-full"
 >
 <Plus className="h-4 w-4 mr-2" />
 Adicionar E-mail
 </ShadcnButton>
 </div>
 )
}

